<template>
<div v-if="show_btn == 'true'">
    <div class="d-flex justify-content-around p-3">
      <button id="booknow_btn" class="btn btn btn-primary btn-sm abw_cart_checkout_btn" type="button" data-toggle="collapse" data-target="#abw_book_now_cb" aria-expanded="false" aria-controls="collapseExample">
        Book Now &nbsp;
        <i class="fa fa-chevron-up pull-right"></i>
        <i class="fa fa-chevron-down pull-right"></i>
      </button>
    </div>
    
    <div class="collapse" id="abw_book_now_cb">
      <div class="container">
        <search-bar v-if="show_date_picker == 'true'" :searchbar_date="this.$store.getters.getSearchDate"></search-bar>
        <main-stepper></main-stepper>
      </div>
    </div>
  </div>
<div v-else>
    <div class="container">
        <Header></Header>
          <search-bar v-if="show_date_picker == 'true' && this.isDisplaydate" :searchbar_date="this.$store.getters.getSearchDate"></search-bar>
        <main-stepper></main-stepper>
      </div>
</div>

</template>

<script>
import APIService from "./services/api_service";
import Header from './components/Header.vue';
import MainStepper from './components/MainStepper.vue';
import SearchBar from "./components/SearchBar.vue";

export default {
  name: "App",
  data() {
    return {
      show_btn: true,
      show_date_picker: true,
      transactionStatus: null,
    };
  },
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  beforeMount() {
    this.$store.subscribe((mutation) => {
      console.log(mutation.type, 'TYPEEEEEEEEEEE');
    });

    if (document.getElementById('show_btn')) {
      this.show_btn = document.getElementById('show_btn').value;
    } else {
      this.show_btn = true;
    }

    if (document.getElementById('show_date_picker')) {
      this.show_date_picker = document.getElementById('show_date_picker').value;
    } else {
      this.show_date_picker = true;
    }
  },
  mounted(){
    APIService.getTransactionStatus(this.trackingId)
      .then((json) => {
        if(json.status == "Completed"){
          this.$store.commit('clearCart');
          this.$store.commit("setPaymentLink", '');
          setTimeout(() => {
            this.$router.go(0);
            // location.reload();
          }, 2000); 
        }
        return;
      })
      .catch((err) => 
        {
          console.log(err);
        }
      );

  },
  computed: {
    isDisplaydate() {
      return this.$store.getters.getDisplayDate;
    },
    trackingId() {
      const url = this.$store.getters.getPaymentLink;
      if(url){
        this.$store.commit('setDisplayDate', true);
        // Create a URLSearchParams object by passing the URL
        const urlParams = new URLSearchParams(new URL(url).search);
  
        // Get the value of OrderTrackingId parameter
        const orderTrackingId = urlParams.get('OrderTrackingId');
        return orderTrackingId;
      }else{
        this.$store.commit('setDisplayDate', true);
        return url;
      }
    },
  },
  components: {
    Header,
    MainStepper,
    SearchBar,
  },
};
</script>


<style>
@import '../public/assets/css/template.css';
@import url(https://use.fontawesome.com/e220fd8e50.css);

button[aria-expanded=true] .fa-chevron-down {
   display: none;
}
button[aria-expanded=false] .fa-chevron-up {
   display: none;
}

</style>
